import { apiSlice, asyncToastDisplay, i18n } from "./apiSlice";

export const columnMappingApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getColumnMappingReferences: builder.query({
      query: (dataType) => "/column_mappings/references/" + dataType,
      providesTags: (result, error, arg) => [{ type: 'ColumnMapping', id: arg }],
    })
  }),
  overrideExisting: false
})

export const {
  useGetColumnMappingReferencesQuery
} = columnMappingApiSlice
